import { useEffect, useState } from 'react';
import { API } from '../utils/API';
import { Profile } from '../models/Profile';
import { useUIContext } from '../context/UIContext';
import { getAuthToken } from '../utils/APIConfig';

export const useProfile = () => {
  const { loader, toast } = useUIContext();

  const [profile, setProfile] = useState<Profile>();

  const fetchProfile = () => new Promise<Profile>(async (resolve, reject) => {
    loader.showLoader();
    try {
      const response = await API.Users.profile();
      setProfile(response);
      resolve(response);
    } catch (error: any) {
      toast.showToast(error.message, 'ERROR');
      reject(error);
    } finally {
      loader.hideLoader();
    }
  });

  useEffect(() => {
    const token = getAuthToken();
    if (!token) return;
    fetchProfile().finally(() => undefined);
  }, []);

  return {
    fetchProfile,
    profile,
  };
};
